import Phaser from 'phaser';
import { generateBiome1Decor, generateBiome2Decor } from '../systems/DecorTextures';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('BootScene');
  }

  preload() {
    // AI-сгенерированные ассеты. ?v=N — cache-bust для nginx.
    const V = '?v=9';

    // Биом 1 — фон, стена, декор
    this.load.image('biome1-bg', `assets/biome1/bg.png${V}`);
    this.load.image('biome1-bg-cathedral', `assets/biome1/bg-cathedral.png${V}`);
    this.load.image('biome1-bg-crypt', `assets/biome1/bg-crypt.png${V}`);
    this.load.image('biome1-bg-temple', `assets/biome1/bg-temple.png${V}`);
    this.load.image('biome1-wall', `assets/biome1/wall.png${V}`);
    this.load.image('biome1-column', `assets/biome1/column.png${V}`);
    this.load.image('biome1-rubble', `assets/biome1/rubble.png${V}`);

    // Биом 2 — абисс/пещеры (чёрный камень с малиновыми трещинами)
    this.load.image('biome2-wall', `assets/biome2/wall.png${V}`);
    this.load.image('biome2-bg-crystals', `assets/biome2/bg-crystals.png${V}`);
    this.load.image('biome2-bg-lava', `assets/biome2/bg-lava.png${V}`);
    this.load.image('biome2-bg-flora', `assets/biome2/bg-flora.png${V}`);

    // Персонажи. По умолчанию герой с мечом ('player'). Во время удара
    // поверх кладётся overlay 'player-noweapon' — статический меч исчезает.
    // После удара overlay плавно растворяется (700мс) — меч появляется обратно.
    // Body всегда на main 'player' спрайте, поэтому смена текстуры не вызывает
    // проваливания (body не пересчитывается).
    this.load.image('player', `assets/characters/hero.png${V}`);
    this.load.image('player-noweapon', `assets/characters/hero-noweapon.png${V}`);
    this.load.image('enemy', `assets/characters/enemy-crawler.png${V}`);
    this.load.image('enemy-floater', `assets/characters/enemy-floater.png${V}`);
    this.load.image('enemy-mantis', `assets/characters/enemy-mantis.png${V}`);

    // Снаряд заклинания (Vengeful Spirit)
    this.load.image('projectile', `assets/characters/projectile.png${V}`);

    // === Высококачественные AI-сгенерированные ассеты для новых врагов ===
    this.load.image('enemy-floater-hq', `assets/characters/enemy-floater-v2.png${V}`);
    this.load.image('enemy-dropper-hq', `assets/characters/enemy-dropper-v2.png${V}`);
    this.load.image('enemy-hopper-hq', `assets/characters/enemy-hopper-v2.png${V}`);

    // === HQ-декорации (14 штук, painterly digital art в стилистике Hollow Knight,
    // с прозрачным фоном через rembg). Биом 1 акцент на руинах/обломках. ===
    this.load.image('decor-b1-lantern', `assets/decor/b1-lantern.png${V}`);
    this.load.image('decor-b1-banner', `assets/decor/b1-banner.png${V}`);
    this.load.image('decor-b1-stone-block', `assets/decor/b1-stone-block.png${V}`);
    // 9 вариантов обломков (груды камней)
    this.load.image('decor-b1-rubble', `assets/decor/b1-rubble.png${V}`);
    this.load.image('decor-b1-rubble-2', `assets/decor/b1-rubble-2.png${V}`);
    this.load.image('decor-b1-rubble-3', `assets/decor/b1-rubble-3.png${V}`);
    this.load.image('decor-b1-rubble-4', `assets/decor/b1-rubble-4.png${V}`);
    this.load.image('decor-b1-rubble-5', `assets/decor/b1-rubble-5.png${V}`);
    this.load.image('decor-b1-rubble-6', `assets/decor/b1-rubble-6.png${V}`);
    this.load.image('decor-b1-rubble-7', `assets/decor/b1-rubble-7.png${V}`);
    this.load.image('decor-b1-rubble-8', `assets/decor/b1-rubble-8.png${V}`);
    this.load.image('decor-b1-rubble-9', `assets/decor/b1-rubble-9.png${V}`);
    // 5 вариантов надгробий (для групповых композиций)
    this.load.image('decor-b1-tombstone', `assets/decor/b1-tombstone.png${V}`);
    this.load.image('decor-b1-tombstone-2', `assets/decor/b1-tombstone-2.png${V}`);
    this.load.image('decor-b1-tombstone-3', `assets/decor/b1-tombstone-3.png${V}`);
    this.load.image('decor-b1-tombstone-4', `assets/decor/b1-tombstone-4.png${V}`);
    this.load.image('decor-b1-tombstone-5', `assets/decor/b1-tombstone-5.png${V}`);
    this.load.image('decor-b2-crystal-cluster', `assets/decor/b2-crystal-cluster.png${V}`);
    this.load.image('decor-b2-crystal-cluster-2', `assets/decor/b2-crystal-cluster-2.png${V}`);
    this.load.image('decor-b2-crystal-cluster-3', `assets/decor/b2-crystal-cluster-3.png${V}`);
    this.load.image('decor-b2-crystal-cluster-4', `assets/decor/b2-crystal-cluster-4.png${V}`);
    this.load.image('decor-b2-stalagmite', `assets/decor/b2-stalagmite.png${V}`);
    this.load.image('decor-b2-mushroom', `assets/decor/b2-mushroom.png${V}`);
    this.load.image('decor-b2-mushroom-2', `assets/decor/b2-mushroom-2.png${V}`);
    this.load.image('decor-b2-mushroom-3', `assets/decor/b2-mushroom-3.png${V}`);
    this.load.image('decor-b2-mushroom-4', `assets/decor/b2-mushroom-4.png${V}`);
    this.load.image('decor-b2-crystal-pillar', `assets/decor/b2-crystal-pillar.png${V}`);
    this.load.image('decor-b2-puddle', `assets/decor/b2-puddle.png${V}`);
    this.load.image('decor-b2-bones', `assets/decor/b2-bones.png${V}`);

    // Программный меч (горизонтальная ориентация, кончик справа на x=148).
    // AI-меч имел диагональную ориентацию, что ломало радиальное позиционирование.
    const g = this.make.graphics({ x: 0, y: 0 });
    g.fillStyle(0x4a3a26, 1);
    g.fillRect(0, 15, 4, 6); // pommel
    g.fillStyle(0x6a4f30, 1);
    g.fillRect(2, 16, 18, 4); // handle wrap
    g.fillStyle(0x8a6c44, 1);
    g.fillRect(20, 12, 12, 12); // cross-guard
    g.fillStyle(0xa8a8b0, 1);
    g.fillRect(32, 16, 110, 4); // blade body
    g.fillStyle(0xe8e8f0, 1);
    g.fillRect(32, 15, 110, 1); // top highlight
    g.fillStyle(0x808088, 1);
    g.fillRect(32, 19, 110, 1); // bottom shadow
    g.fillStyle(0xb8b8c0, 1);
    // Pointed tip — light triangle (using two thin rects approximating a wedge)
    g.fillRect(142, 16, 4, 4);
    g.fillRect(146, 17, 2, 2);
    g.lineStyle(1, 0x404048, 1);
    g.strokeRect(32, 15, 110, 6);
    g.generateTexture('sword', 150, 36);
    g.clear();

    // Портал-зеркало. Арочная форма с тёплым свечением — заменяет скамейку,
    // герой материализуется из него при респауне.
    const PW = 84;
    const PH = 144;
    const pcx = PW / 2;
    const pcy = PH * 0.46;

    // Радиальный градиент свечения (несколько эллипсов с убывающим alpha)
    g.fillStyle(0x6a3a14, 0.35);
    g.fillEllipse(pcx, pcy, PW * 1.0, PH * 0.92);
    g.fillStyle(0xc46a28, 0.45);
    g.fillEllipse(pcx, pcy, PW * 0.78, PH * 0.78);
    g.fillStyle(0xf2a854, 0.55);
    g.fillEllipse(pcx, pcy, PW * 0.6, PH * 0.66);
    g.fillStyle(0xffd28a, 0.7);
    g.fillEllipse(pcx, pcy, PW * 0.42, PH * 0.5);
    g.fillStyle(0xfff0c8, 0.85);
    g.fillEllipse(pcx, pcy, PW * 0.22, PH * 0.32);

    // Внешняя каменная рамка — тёмный готический контур
    g.lineStyle(8, 0x141a22, 1);
    g.strokeRoundedRect(4, 4, PW - 8, PH - 18, {
      tl: PW / 2 - 4,
      tr: PW / 2 - 4,
      bl: 4,
      br: 4,
    });
    // Внутренняя бронзовая кромка
    g.lineStyle(2, 0x8a6438, 0.8);
    g.strokeRoundedRect(10, 10, PW - 20, PH - 30, {
      tl: PW / 2 - 10,
      tr: PW / 2 - 10,
      bl: 2,
      br: 2,
    });

    // Постамент (основание портала на земле)
    g.fillStyle(0x1f242c, 1);
    g.fillRect(0, PH - 20, PW, 20);
    g.fillStyle(0x3a4250, 1);
    g.fillRect(0, PH - 20, PW, 3);
    g.lineStyle(1, 0x0a0d12, 1);
    g.strokeRect(0, PH - 20, PW, 20);
    // Декоративная резьба на постаменте
    g.fillStyle(0x10141a, 1);
    g.fillRect(8, PH - 14, 4, 8);
    g.fillRect(PW - 12, PH - 14, 4, 8);
    g.fillRect(PW / 2 - 2, PH - 14, 4, 8);

    g.generateTexture('portal', PW, PH);
    g.clear();

    // === Телепорт между биомами — вертикальный вихрь ===
    // Стилистически отличается от портала: малиновое свечение и узкий силуэт.
    const TW = 110;
    const TH = 180;
    // Внешнее свечение (несколько эллипсов с убывающим alpha → радиальный градиент)
    g.fillStyle(0x4a0a2a, 0.35);
    g.fillEllipse(TW / 2, TH * 0.5, TW * 1.0, TH * 0.95);
    g.fillStyle(0x9a1a5a, 0.45);
    g.fillEllipse(TW / 2, TH * 0.5, TW * 0.78, TH * 0.78);
    g.fillStyle(0xd83a8a, 0.6);
    g.fillEllipse(TW / 2, TH * 0.5, TW * 0.55, TH * 0.62);
    g.fillStyle(0xff7aa8, 0.7);
    g.fillEllipse(TW / 2, TH * 0.5, TW * 0.36, TH * 0.45);
    g.fillStyle(0xffd0e0, 0.85);
    g.fillEllipse(TW / 2, TH * 0.5, TW * 0.18, TH * 0.28);

    // Кольца — концентрические штрихи в малиновой палитре
    g.lineStyle(2, 0xff8ab8, 0.55);
    g.strokeEllipse(TW / 2, TH * 0.5, TW * 0.42, TH * 0.5);
    g.lineStyle(1, 0xffb0d0, 0.7);
    g.strokeEllipse(TW / 2, TH * 0.5, TW * 0.62, TH * 0.7);
    g.lineStyle(1, 0xa8285a, 0.45);
    g.strokeEllipse(TW / 2, TH * 0.5, TW * 0.82, TH * 0.86);

    // Постамент из чёрного камня
    g.fillStyle(0x0a0d12, 1);
    g.fillRect(0, TH - 18, TW, 18);
    g.fillStyle(0x2a1830, 1);
    g.fillRect(0, TH - 18, TW, 2);
    g.lineStyle(1, 0x000000, 1);
    g.strokeRect(0, TH - 18, TW, 18);

    g.generateTexture('teleport', TW, TH);
    g.clear();

    // === Артефакты ===
    // 4 уникальные иконки, по 2 на биом. Биом 1 — археология (золото/камень),
    // биом 2 — абисс (чёрный камень с малиновым свечением).
    const AS = 36; // размер квадрата иконки

    // a1 — золотая маска рыцаря (биом 1)
    g.fillStyle(0x6a4a20, 1);
    g.fillEllipse(AS / 2, AS / 2, 26, 30); // тёмная подложка
    g.fillStyle(0xd9a648, 1);
    g.fillEllipse(AS / 2, AS / 2, 22, 26); // золото
    g.fillStyle(0xfde084, 1);
    g.fillEllipse(AS / 2, AS / 2 - 2, 18, 16); // блик
    g.fillStyle(0x2a1810, 1);
    g.fillEllipse(AS / 2 - 4, AS / 2 + 2, 3, 4); // глазницы
    g.fillEllipse(AS / 2 + 4, AS / 2 + 2, 3, 4);
    g.lineStyle(1, 0x4a2f12, 0.8);
    g.strokeEllipse(AS / 2, AS / 2, 22, 26);
    g.generateTexture('artefact-a1', AS, AS);
    g.clear();

    // a2 — скрижаль с письменами (биом 1)
    g.fillStyle(0x3a3026, 1);
    g.fillRoundedRect(6, 4, 24, 28, 3); // подложка
    g.fillStyle(0x9c8870, 1);
    g.fillRoundedRect(7, 5, 22, 26, 2); // камень
    g.fillStyle(0xc4ad8a, 0.6);
    g.fillRect(7, 5, 22, 2); // верхний блик
    g.fillStyle(0x2a1f10, 1); // надписи
    g.fillRect(10, 11, 16, 1);
    g.fillRect(10, 14, 12, 1);
    g.fillRect(10, 17, 16, 1);
    g.fillRect(10, 20, 10, 1);
    g.fillRect(10, 23, 14, 1);
    g.lineStyle(1, 0x1a1208, 0.8);
    g.strokeRoundedRect(6, 4, 24, 28, 3);
    g.generateTexture('artefact-a2', AS, AS);
    g.clear();

    // a3 — кристалл абисса (биом 2) — острая шипа в малиновой ауре
    g.fillStyle(0xc83c80, 0.18); // ореол
    g.fillCircle(AS / 2, AS / 2, 16);
    g.fillStyle(0xff6aa8, 0.32);
    g.fillCircle(AS / 2, AS / 2, 12);
    // Кристалл-ромб
    g.fillStyle(0x2a0a1a, 1);
    g.fillPoints(
      [
        { x: AS / 2, y: 6 },
        { x: AS / 2 + 7, y: AS / 2 },
        { x: AS / 2, y: AS - 6 },
        { x: AS / 2 - 7, y: AS / 2 },
      ],
      true,
      true,
    );
    g.fillStyle(0xc83c80, 1);
    g.fillPoints(
      [
        { x: AS / 2, y: 8 },
        { x: AS / 2 + 5, y: AS / 2 },
        { x: AS / 2, y: AS - 8 },
        { x: AS / 2 - 5, y: AS / 2 },
      ],
      true,
      true,
    );
    g.fillStyle(0xff90c0, 0.85); // блик
    g.fillTriangle(AS / 2, 9, AS / 2 + 3, AS / 2 - 2, AS / 2, AS / 2 - 1);
    g.generateTexture('artefact-a3', AS, AS);
    g.clear();

    // a4 — глазной символ абисса (биом 2)
    g.fillStyle(0x2a0a1a, 1); // тёмный круг-обод
    g.fillCircle(AS / 2, AS / 2, 14);
    g.fillStyle(0x1a0612, 1); // глубокий внутренний
    g.fillCircle(AS / 2, AS / 2, 12);
    // «Глаз» — горизонтальный овал
    g.fillStyle(0xc83c80, 1);
    g.fillEllipse(AS / 2, AS / 2, 18, 8);
    g.fillStyle(0xff6aa8, 1);
    g.fillEllipse(AS / 2, AS / 2, 14, 6);
    g.fillStyle(0x140510, 1); // зрачок
    g.fillEllipse(AS / 2, AS / 2, 6, 6);
    g.fillStyle(0xff90c0, 0.7); // блик
    g.fillCircle(AS / 2 - 1, AS / 2 - 1, 1);
    g.lineStyle(1, 0x6a1830, 1);
    g.strokeCircle(AS / 2, AS / 2, 14);
    g.generateTexture('artefact-a4', AS, AS);
    g.clear();

    // === Орб (снаряд EnemyDropper) ===
    const ORB = 22;
    g.fillStyle(0x6a1a40, 0.4); // ореол
    g.fillCircle(ORB / 2, ORB / 2, 10);
    g.fillStyle(0xd83a8a, 0.85);
    g.fillCircle(ORB / 2, ORB / 2, 7);
    g.fillStyle(0xff90c0, 1);
    g.fillCircle(ORB / 2, ORB / 2, 4);
    g.fillStyle(0xfff0d8, 0.85);
    g.fillCircle(ORB / 2 - 1, ORB / 2 - 1, 1.5);
    g.generateTexture('orb', ORB, ORB);
    g.clear();

    // === Texture Floater (диагональный летающий) ===
    // Шарообразный жук с двумя «крыльями»-выступами
    const FL = 60;
    g.fillStyle(0x142028, 1); // тело
    g.fillEllipse(FL / 2, FL / 2, 38, 28);
    g.fillStyle(0x2a3848, 1);
    g.fillEllipse(FL / 2, FL / 2 - 2, 30, 18); // верхний блик
    g.fillStyle(0x6a8aa0, 0.9);
    g.fillEllipse(FL / 2, FL / 2 - 4, 18, 8); // ярче
    // Крылья
    g.fillStyle(0x0a1018, 0.9);
    g.fillEllipse(FL / 2 - 18, FL / 2 + 1, 12, 16);
    g.fillEllipse(FL / 2 + 18, FL / 2 + 1, 12, 16);
    // Глаз
    g.fillStyle(0xff5577, 1);
    g.fillCircle(FL / 2, FL / 2, 3);
    g.fillStyle(0xffffff, 0.9);
    g.fillCircle(FL / 2 - 1, FL / 2 - 1, 1);
    g.generateTexture('enemy-floater-new', FL, FL);
    g.clear();

    // === Texture Dropper (плавающий под потолком, бомбовоз) ===
    // Бесформенный «медузовый» силуэт с длинными щупальцами
    const DR = 80;
    g.fillStyle(0x2a1832, 1); // тело
    g.fillEllipse(DR / 2, DR * 0.35, 50, 32);
    g.fillStyle(0x4a2848, 1);
    g.fillEllipse(DR / 2, DR * 0.32, 40, 22);
    g.fillStyle(0x8a4a78, 0.7);
    g.fillEllipse(DR / 2, DR * 0.28, 24, 10);
    // Щупальца — несколько свисающих линий
    g.fillStyle(0x3a1830, 1);
    g.fillRect(DR / 2 - 18, DR * 0.42, 3, 28);
    g.fillRect(DR / 2 - 8, DR * 0.46, 3, 32);
    g.fillRect(DR / 2 + 4, DR * 0.46, 3, 30);
    g.fillRect(DR / 2 + 14, DR * 0.42, 3, 26);
    // Малиновые «глазки»
    g.fillStyle(0xff5aa0, 1);
    g.fillCircle(DR / 2 - 8, DR * 0.32, 2);
    g.fillCircle(DR / 2 + 8, DR * 0.32, 2);
    g.generateTexture('enemy-dropper', DR, DR);
    g.clear();

    // === Texture Hopper — стимпанк механический жук-«лягушка» ===
    // В палитре игры: тёмный гунметал-сине-серый (как у платформ), бронзовые
    // заклёпки и трубки, единственный циклоп-глаз с тёплым оранжевым свечением
    // (как у портала и фоновых огней). Никакого «зелёного лягушачьего».
    const HP = 64;
    const cx = HP / 2;
    const cy = HP / 2;

    // Бедро / задние «поршневые» лапы (сжаты в покое)
    g.fillStyle(0x1c2230, 1);
    g.fillRoundedRect(cx - 24, cy + 10, 12, 12, 3);
    g.fillRoundedRect(cx + 12, cy + 10, 12, 12, 3);
    // Голень-поршень (светлее, металлический блеск)
    g.fillStyle(0x4a525a, 1);
    g.fillRect(cx - 28, cy + 18, 6, 8);
    g.fillRect(cx + 22, cy + 18, 6, 8);
    // Ступня — плоская, металлическая
    g.fillStyle(0x0e1218, 1);
    g.fillRoundedRect(cx - 32, cy + 24, 14, 5, 2);
    g.fillRoundedRect(cx + 18, cy + 24, 14, 5, 2);
    // Бронзовые крепления (заклёпки) на лапах
    g.fillStyle(0x8a6438, 1);
    g.fillCircle(cx - 18, cy + 16, 1.5);
    g.fillCircle(cx + 18, cy + 16, 1.5);

    // Корпус — основа в тёмной гамме платформ
    g.fillStyle(0x232b3a, 1);
    g.fillRoundedRect(cx - 22, cy - 8, 44, 26, 8);
    // Светлая полоса сверху — отражённый свет
    g.fillStyle(0x3a4456, 1);
    g.fillEllipse(cx, cy - 5, 36, 12);
    // Бронзовое «брюхо» внизу корпуса
    g.fillStyle(0x5a3e1c, 1);
    g.fillRoundedRect(cx - 18, cy + 6, 36, 12, 5);

    // Заклёпки по корпусу
    g.fillStyle(0x8a6438, 1);
    g.fillCircle(cx - 16, cy - 4, 1.5);
    g.fillCircle(cx + 16, cy - 4, 1.5);
    g.fillCircle(cx - 14, cy + 11, 1.5);
    g.fillCircle(cx + 14, cy + 11, 1.5);
    // Маленькие блики на заклёпках
    g.fillStyle(0xe8c878, 0.8);
    g.fillCircle(cx - 16.3, cy - 4.3, 0.5);
    g.fillCircle(cx + 15.7, cy - 4.3, 0.5);

    // Паровые трубки сверху (две трубы с расширениями-навершиями)
    g.fillStyle(0x2a323c, 1);
    g.fillRect(cx - 10, cy - 18, 4, 10);
    g.fillRect(cx + 6, cy - 18, 4, 10);
    g.fillStyle(0x6a4a28, 1);
    g.fillRect(cx - 12, cy - 20, 8, 3);
    g.fillRect(cx + 4, cy - 20, 8, 3);
    // Лёгкий «парок» — туманный белый над трубками
    g.fillStyle(0xc8c4d0, 0.4);
    g.fillCircle(cx - 8, cy - 24, 2);
    g.fillCircle(cx + 8, cy - 24, 2);

    // Главный глаз — большая линза-циклоп с тёплым свечением
    g.fillStyle(0x141a22, 1);
    g.fillCircle(cx, cy - 1, 9);
    g.fillStyle(0x6a4a28, 1);
    g.fillCircle(cx, cy - 1, 8); // бронзовая оправа
    g.fillStyle(0x1a1208, 1);
    g.fillCircle(cx, cy - 1, 6.5); // тёмное стекло
    g.fillStyle(0xc8732a, 1);
    g.fillCircle(cx, cy - 1, 5); // оранжевое ядро
    g.fillStyle(0xffd070, 0.95);
    g.fillCircle(cx, cy - 1, 2.5); // яркое свечение
    g.fillStyle(0xfff5d8, 0.9);
    g.fillCircle(cx - 1, cy - 2, 1); // блик

    g.generateTexture('enemy-hopper', HP, HP);
    g.destroy();

    // === Декоративные объекты для биомов (40 текстур: 20 + 20) ===
    // Размещаются на новом «4-м плане» (depth=5) через DecorItem.
    generateBiome1Decor(this);
    generateBiome2Decor(this);

    // === Виньетка (радиальное затемнение краёв вьюпорта) ===
    // Накладывается фиксированно поверх мира (scrollFactor 0,0). Слабое — даёт
    // атмосферу «мрака и тумана» по краям, не мешая видимости геймплея.
    const VW = 1067;
    const VH = 600;
    const vCanvas = this.textures.createCanvas('vignette', VW, VH);
    if (vCanvas) {
      const vctx = vCanvas.getContext();
      const innerR = Math.min(VW, VH) * 0.3;
      const outerR = Math.max(VW, VH) * 0.72;
      const vgrad = vctx.createRadialGradient(VW / 2, VH / 2, innerR, VW / 2, VH / 2, outerR);
      vgrad.addColorStop(0, 'rgba(0,0,0,0)');
      vgrad.addColorStop(0.55, 'rgba(0,0,0,0.06)');
      vgrad.addColorStop(1, 'rgba(0,0,0,0.5)');
      vctx.fillStyle = vgrad;
      vctx.fillRect(0, 0, VW, VH);
      vCanvas.refresh();
    }

    // === Аура лечения (Focus) — плавный радиальный градиент ===
    // Тёплый «туман» от золотисто-кремового центра до полностью прозрачного
    // края. Canvas API даёт по-настоящему гладкий gradient без видимых
    // ступеней alpha. Используется как Image со скейлом и blend ADD.
    const FAW = 256;
    const FAH = 256;
    const faCanvas = this.textures.createCanvas('focus-aura', FAW, FAH);
    if (faCanvas) {
      const fctx = faCanvas.getContext();
      const fcx = FAW / 2;
      const fcy = FAH / 2;
      const fgrad = fctx.createRadialGradient(fcx, fcy, 0, fcx, fcy, FAW / 2);
      fgrad.addColorStop(0, 'rgba(255,248,216,0.85)');
      fgrad.addColorStop(0.18, 'rgba(255,232,168,0.6)');
      fgrad.addColorStop(0.42, 'rgba(255,210,118,0.28)');
      fgrad.addColorStop(0.72, 'rgba(255,188,80,0.09)');
      fgrad.addColorStop(1, 'rgba(255,180,60,0)');
      fctx.fillStyle = fgrad;
      fctx.fillRect(0, 0, FAW, FAH);
      faCanvas.refresh();
    }

    // === Маска плавного схождения bg-сегментов ===
    // Горизонтальный alpha-градиент: alpha=0 у краёв, alpha=1 в центре.
    // Применяется как BitmapMask к каждому bg-сегменту, чтобы соседние
    // картинки переходили друг в друга бесшовно, без жёсткого среза.
    const FW = 1024;
    const FH = 256;
    const fCanvas = this.textures.createCanvas('bg-fade-mask', FW, FH);
    if (fCanvas) {
      const fctx = fCanvas.getContext();
      const fgrad = fctx.createLinearGradient(0, 0, FW, 0);
      fgrad.addColorStop(0, 'rgba(255,255,255,0)');
      fgrad.addColorStop(0.22, 'rgba(255,255,255,1)');
      fgrad.addColorStop(0.78, 'rgba(255,255,255,1)');
      fgrad.addColorStop(1, 'rgba(255,255,255,0)');
      fctx.fillStyle = fgrad;
      fctx.fillRect(0, 0, FW, FH);
      fCanvas.refresh();
    }
  }

  create() {
    this.scene.start('GameScene');
  }
}
